import dayjs from 'dayjs'
import { i18nService } from '@accor/customer-vue-services'
import { getAdsLocale } from '@accor/ads-components-locales'
import type { SupportedLocales as AdsSupportedLocales } from '@accor/shared-utils'

i18nService.configure(
  async (locale: string) => {
    setDayJsLocale(locale)
    const aabMessages = await import(`@/assets/locales/aab/${locale}.json`)
    const b2cMessages = await import(`@/assets/locales/b2c/${locale}.json`)
    const adsMessages = await getAdsLocale(locale as AdsSupportedLocales)
    const mergedMessages = { ...b2cMessages, ...aabMessages, ...adsMessages }

    return mergedMessages
  },
  {
    supportedLocales: [
      'ar',
      'de',
      'es',
      'fr',
      'en',
      'id',
      'it',
      'ja',
      'ko',
      'nl',
      'pl',
      'pt',
      'pt-br',
      'ru',
      'th',
      'tr',
      'zh'
    ]
  }
)

i18nService.addLocaleLoader((locale: string) => {
  return import(`@/assets/locales/aab/${locale}.json`)
})

const setDayJsLocale = async (locale: string) => {
  try {
    const dayJsLocale = await import(`../../node_modules/dayjs/esm/locale/${locale}.js`)
    dayjs.locale(dayJsLocale)
  } catch {
    console.warn('dayjs locale not loaded')
  }
}

// Keep for now as it is used in e2e tests
export async function loadLocaleMessages(locale: string, messages: object) {
  i18nService.i18n.global.locale = locale
  i18nService.i18n.global.setLocaleMessage(locale, messages)
  await setDayJsLocale(locale)
}
